import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import ForwaedHelixPiercingImage from '../../Assets/Piercing Services/forward helix piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function ForwaedHelixPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Forwaed Helix Piercing UAE | 150 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Forwaed Helix Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Forwaed Helix Piercing 150 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={ForwaedHelixPiercingImage} alt="Forwaed Helix Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Forwaed Helix Piercing</h3>

          <p>
            Enhance your ear styling with our professional forward helix piercing services in the UAE, available at an affordable price of 150 AED. Forward helix piercing is a trendy and stylish cartilage piercing located on the front outer rim of the ear, just above the tragus, making it a perfect choice for those who want a modern and elegant look. This unique placement allows for a subtle yet eye-catching appearance that beautifully frames the face. Whether you prefer a minimal stud, a delicate gemstone, or a small hoop, forward helix piercing offers versatility and sophistication, making it suitable for both everyday wear and special occasions.
          </p>

          <p>
            At our piercing studio, we prioritize safety, hygiene, and comfort to provide a premium experience for every client. Our certified professionals use sterile, single-use, high-quality equipment to perform each forward helix piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth procedure. Our goal is to deliver a quick, efficient, and pain-minimized experience, making forward helix piercing ideal for both first-time clients and those expanding their ear piercing collection.
          </p>

          <p>
            Forward helix piercing is perfect for individuals who want to add a refined and contemporary touch to their ear design. It pairs beautifully with other piercings such as lobe, helix, tragus, or conch, allowing you to create a curated and layered ear style that reflects your personality. Our expert specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to achieve your desired look. Whether you want a single forward helix piercing or plan to add multiple piercings in the future, we ensure a customized and stylish result.
          </p>

          <p>
            The procedure is typically completed within minutes, ensuring minimal discomfort and maximum convenience. Our team uses advanced techniques designed to reduce pain and promote faster healing, allowing you to enjoy your new piercing without unnecessary stress. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings can sometimes feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your forward helix piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your forward helix piercing will heal effectively and remain a stylish and long-lasting addition to your look.
          </p>

          <p>
            Our forward helix piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted forward helix piercing services in the UAE for a safe, stylish, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a modern and elegant look effortlessly. Book your forward helix piercing appointment today and elevate your ear styling with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Forwaed Helix Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ForwaedHelixPiercing;